import { render, staticRenderFns } from "./request.vue?vue&type=template&id=f218ce5a&scoped=true&"
import script from "./request.vue?vue&type=script&lang=js&"
export * from "./request.vue?vue&type=script&lang=js&"
import style0 from "./request.vue?vue&type=style&index=0&lang=css&"
import style1 from "./request.vue?vue&type=style&index=1&id=f218ce5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f218ce5a",
  null
  
)

export default component.exports